import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";

const SystemHUD = () => {
  const [time, setTime] = useState("");
  const [load, setLoad] = useState(24.8);

  useEffect(() => {
    const timer = setInterval(() => {
      const d = new Date();
      setTime(d.toISOString().slice(11, 19)); // HH:MM:SS
      if (Math.random() > 0.7) {
        setLoad((p) => Math.max(10, Math.min(90, p + (Math.random() - 0.5) * 5)));
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const textStyle = {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "0.65rem",
    color: "rgba(107, 117, 130, 0.8)",
    letterSpacing: "0.15em",
  };

  const cyanText = {
    ...textStyle,
    color: "var(--cyan)",
    textShadow: "0 0 8px rgba(0,240,255,0.4)",
  };

  return (
    <>
      {/* Top Left: Cam/Signal */}
      <Stack spacing={0.5} sx={{ position: "fixed", top: 24, left: 24, zIndex: 10 }}>
        <Typography sx={textStyle}>CAM_04 [REC]</Typography>
        <Typography sx={cyanText} className="sys-blink">SIGNAL_STRONG</Typography>
      </Stack>

      {/* Top Right: Time/ISO */}
      <Stack spacing={0.5} alignItems="flex-end" sx={{ position: "fixed", top: 24, right: 24, zIndex: 10 }}>
        <Typography sx={textStyle}>{time}</Typography>
        <Typography sx={textStyle}>ISO 800</Typography>
      </Stack>

      {/* Bottom Left: Coordinates */}
      <Box className="tactical-border" sx={{
        position: "fixed", bottom: 24, left: 24, zIndex: 10,
        p: 1.5, display: { xs: "none", md: "block" }
      }}>
        <Stack spacing={0.5}>
          <Typography sx={textStyle}>LAT: 23.1815 N</Typography>
          <Typography sx={textStyle}>LON: 79.9864 E</Typography>
          <Typography sx={{ ...textStyle, mt: 1, opacity: 0.5 }}>SECURE_GRID_9</Typography>
          <Typography sx={{ ...textStyle, color: "var(--cyan)", mt: 1 }}>
            SYS_LOAD: {load.toFixed(1)}%
          </Typography>
        </Stack>
      </Box>

      {/* Global Animated Grid & Scanline */}
      <Box className="scanline-bar" />
      <Box className="crt" sx={{ position: "fixed", inset: 0, zIndex: 9999, pointerEvents: "none" }} />
      <Box sx={{
        position: "fixed", inset: 0, opacity: 0.05, pointerEvents: "none", zIndex: 0,
        backgroundImage: `
          linear-gradient(rgba(0, 240, 255, 0.3) 1px, transparent 1px),
          linear-gradient(90deg, rgba(0, 240, 255, 0.3) 1px, transparent 1px)
        `,
        backgroundSize: "40px 40px",
      }} />
      <Box sx={{
        position: "fixed", inset: 0, opacity: 0.03, pointerEvents: "none", zIndex: 0,
        backgroundImage: `
          linear-gradient(rgba(0, 240, 255, 0.5) 1px, transparent 1px),
          linear-gradient(90deg, rgba(0, 240, 255, 0.5) 1px, transparent 1px)
        `,
        backgroundSize: "200px 200px",
      }} />
    </>
  );
};

export default SystemHUD;
